import { render, staticRenderFns } from "./PgaEditButton.vue?vue&type=template&id=e97b8e90&"
import script from "./PgaEditButton.vue?vue&type=script&lang=ts&"
export * from "./PgaEditButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e97b8e90')) {
      api.createRecord('e97b8e90', component.options)
    } else {
      api.reload('e97b8e90', component.options)
    }
    module.hot.accept("./PgaEditButton.vue?vue&type=template&id=e97b8e90&", function () {
      api.rerender('e97b8e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaEditButton.vue"
export default component.exports